import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=320da5a1&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=js&"
export * from "./scene.vue?vue&type=script&lang=js&"
import style0 from "./scene.vue?vue&type=style&index=0&id=320da5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320da5a1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Images: require('/var/www/mbm.garena.all/frontend/components/scene/Images.vue').default,Videos: require('/var/www/mbm.garena.all/frontend/components/scene/Videos.vue').default})
